export default __webpack_public_path__ + "static/Plots0092-7b960757131a27661aede115c8635748.jpg";